import { Section, TableOfContent } from '../../../typings/interfaces';
import { HINDI } from '../../../assets/images';
// Hindi
const HISection: Section[] = [
  {
    name: '1: संदर्भ एवं अवलोकन',
    subSections: [
      {
        name: 'प्रस्तावना',
        page: 3,
      },
      {
        name: 'उद्देश्य एवं क्षेत्र मार्गदरन अन ्श ुप्रयोग',
        page: 4,
      },
      {
        name: 'प्रमुख परिभाषाएँ',
        page: 5,
      },
      {
        name: 'नियंत्रण पदानुक्रम',
        page: 6,
      },
    ],
  },
  {
    name: '2: जीवनरक्षक',
    subSections: [
      {
        name: 'मोटर वाहन – यातायात सुरक',
        page: 9,
      },
      {
        name: 'ऊं चाई पर काम करना',
        page: 12,
      },
      {
        name: 'मोबाइल संचालित उपकरण (MPE)',
        page: 18,
      },
      {
        name: 'लॉकआउट टैगआउट/ऊर्जा पथक्क ृ रण',
        page: 22,
      },
      {
        name: 'बिजली के काम',
        page: 25,
      },
      {
        name: 'सीमित स्थान',
        page: 29,
      },
      {
        name: 'थोक सामग्री एवं भंडारण',
        page: 32,
      },
      {
        name: 'ेलकार सुरक',
        page: 37,
      },
      {
        name: 'खुदाई और खाई के कार',
        page: 41,
      },
      {
        name: 'सामान उठाना और बाँधना',
        page: 45,
      },
      {
        name: 'ख़तरनाक सामग',
        page: 49,
      },
      {
        name: 'ताप-युक्त कार',
        page: 52,
      },
    ],
  },
  {
    name: '3: अतिरिक्त संसाधन एवं साधन',
    subSections: [
      {
        name: `पानी के आस-पास या ऊपर काम करना`,
        page: 56,
      },
      {
        name: 'वस्तु छुटना या गिरना',
        page: 59,
      },
      {
        name: 'वाय मंडलीय/गैस परीक्षण',
        page: 61,
      },
      {
        name: 'रसायनिक ख़तरों से संबंधित संचार',
        page: 65,
      },
    ],
  },
  {
    name: '4: Cargill सुरक्षा प्रबंधन अभ्यास',
    subSections: [
      {
        name: 'म ुख्य शब्',
        page: 70,
      },
      {
        name: 'घटना गंभीर चोट एवं मतृयु (SIF) निर्धारण',
        page: 72,
      },
      {
        name: 'गंभीर चोट एवं मतयु संभाव्यता (SIFp) श्रेणीकरण',
        page: 73,
      },
      {
        name: 'SIF स्वचालित निर्धारण मापदंड तालिका',
        page: 74,
      },
      {
        name: 'मानव और संगठात्मक प्रदरन ्श(HOP)',
        page: 76,
      },
    ],
  },
];
const HITableofContent: TableOfContent = {
  language: 'hi',
  sections: HISection,
  label: 'विषयसूची',
  pdfLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/Cargill Field Safety Guide (hi_IN)_DIGITAL_CROPPED.pdf',
  hopPocket: 'HOP पॉकेट गाइड',
  hopPocketLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/HOP pocket guide content 2021-09-08_Hindi.pdf',
  source: HINDI,
};

export default HITableofContent;
